export default "__VITE_ASSET__3cd751ae__$_?nuxt_component=async__"